import type { EventName } from "@lit/react";
import { Crud as CrudElement, type CrudEventMap as _CrudEventMap, } from "@vaadin/crud/vaadin-crud.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { CrudElement, };
export type CrudEventMap<T1> = Readonly<{
    onCancel: EventName<_CrudEventMap<T1>["cancel"]>;
    onDelete: EventName<_CrudEventMap<T1>["delete"]>;
    onEdit: EventName<_CrudEventMap<T1>["edit"]>;
    onEditedItemChanged: EventName<_CrudEventMap<T1>["edited-item-changed"]>;
    onEditorOpenedChanged: EventName<_CrudEventMap<T1>["editor-opened-changed"]>;
    onItemsChanged: EventName<_CrudEventMap<T1>["items-changed"]>;
    onNew: EventName<_CrudEventMap<T1>["new"]>;
    onSave: EventName<_CrudEventMap<T1>["save"]>;
    onSizeChanged: EventName<_CrudEventMap<T1>["size-changed"]>;
}>;
const events = { onCancel: "cancel", onDelete: "delete", onEdit: "edit", onEditedItemChanged: "edited-item-changed", onEditorOpenedChanged: "editor-opened-changed", onItemsChanged: "items-changed", onNew: "new", onSave: "save", onSizeChanged: "size-changed" } as CrudEventMap<any>;
export type CrudProps<T1> = WebComponentProps<CrudElement<T1>, CrudEventMap<T1>>;
export const Crud = createComponent({
    elementClass: CrudElement, events, react: React, tagName: "vaadin-crud"
}) as <T1>(props: CrudProps<T1> & React.RefAttributes<CrudElement<T1>>) => React.ReactElement | null;
